import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./PartnerSection.module.css";

const partners = [
  { id: 1, name: "KFC", logo: "/logos/client1.webp" },
  { id: 2, name: "TGI Fridays", logo: "/logos/client2.webp" },
  { id: 3, name: "TACO BELL", logo: "/logos/client3.webp" },
  { id: 4, name: "Burger King", logo: "/logos/client4.webp" },
  { id: 5, name: "Hard Rock Cafe", logo: "/logos/client5.webp" },
  { id: 6, name: "Dunkin Donuts", logo: "/logos/client6.webp" },
  { id: 7, name: "KETE", logo: "/logos/client7.webp" },
  { id: 8, name: "Ola", logo: "/logos/client8.webp" },
  { id: 9, name: "Subway", logo: "/logos/client9.webp" },
];

const PartnerSection = () => {
  const { t } = useTranslation();

  return (
    <section className={styles.partners}>
      <h2 className={styles.title}>
        {t("partners.title")}
      </h2>

      <div className={styles.grid}>
        {partners.map((partner) => (
          <div key={partner.id} className={styles.item}>
            <img
              src={partner.logo}
              alt={partner.name}
              className={styles.image}
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default PartnerSection;